export const SET_FILTER = "filters/SET_FILTER";
export const RESET_FILTERES = "filters/RESET_FILTERES";
export const SET_FILTERS = "filters/SET_FILTERS";
